// src/components/PersonalizzaCommessaMenu.js
// Un pannello unico per attivare/disattivare i moduli opzionali di una commessa, al posto
// di 12 bottoni ON/OFF sparsi in fila nella testata. Stessi campi Firestore di sempre —
// nessuna migrazione dati, solo un modo diverso di presentarli.
//
// Il menu a tendina usa un portale React (renderizzato direttamente nel <body>, non dentro
// il bottone) apposta: la testata della commessa ora scorre orizzontalmente quando ci sono
// molti elementi, e un contenitore con scroll "taglia" verticalmente qualunque figlio che
// esce dai suoi bordi — il portale fa scappare il menu da questo limite.
import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { STILE_AVVISO_VIOLA } from "./AvvisoViola";
import { Settings, ChevronDown, Check, Lock } from "lucide-react";

export default function PersonalizzaCommessaMenu({ moduli, onToggle }) {
  const [aperto, setAperto] = useState(false);
  const [posizione, setPosizione] = useState(null);
  const [avviso, setAvviso] = useState(null); // modulo non attivabile da questo utente
  const btnRef = useRef();
  const menuRef = useRef();

  const apri = () => {
    if (aperto) { setAperto(false); return; }
    setAvviso(null);
    const r = btnRef.current.getBoundingClientRect();
    setPosizione({ top: r.bottom + 4, left: r.left });
    setAperto(true);
  };

  useEffect(() => {
    if (!aperto) return;
    const onClickFuori = (e) => {
      if (btnRef.current?.contains(e.target)) return;
      if (menuRef.current?.contains(e.target)) return;
      setAperto(false);
    };
    // Chiude il menu se si scorre la testata (la posizione calcolata non seguirebbe lo scroll)
    const onScrollOChiudi = () => setAperto(false);
    document.addEventListener("mousedown", onClickFuori);
    window.addEventListener("scroll", onScrollOChiudi, true);
    window.addEventListener("resize", onScrollOChiudi);
    return () => {
      document.removeEventListener("mousedown", onClickFuori);
      window.removeEventListener("scroll", onScrollOChiudi, true);
      window.removeEventListener("resize", onScrollOChiudi);
    };
  }, [aperto]);

  const attivi = moduli.filter(m=>m.value).length;

  return (
    <>
      <button ref={btnRef} onClick={apri}
        style={{display:"flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:7,
          border:"1px solid #e5e7eb", background:"#fff", color:"#6b7280",
          fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif",flexShrink:0}}>
        <Settings size={13}/> Personalizza {attivi>0?`(${attivi})`:""}
        <ChevronDown size={12}/>
      </button>
      {aperto && posizione && createPortal(
        <div ref={menuRef} style={{position:"fixed",top:posizione.top,left:posizione.left,background:"#fff",border:"1px solid #e5e7eb",borderRadius:10,boxShadow:"0 8px 24px rgba(0,0,0,.12)",zIndex:1000,minWidth:260,padding:6}}>
          <div style={{padding:"6px 10px",fontSize:10.5,fontWeight:700,color:"#9ca3af",textTransform:"uppercase"}}>Moduli di questa commessa</div>
          {moduli.map(m => (
            <button key={m.key} onClick={()=>{ if (m.bloccato) { setAvviso(m.key); return; } setAvviso(null); onToggle(m); }}
              title={m.bloccato ? (m.economico ? "Modulo economico: lo attivano titolare e amministratori" : "Lo attivano amministratori, responsabile della commessa e chi è abilitato") : undefined}
              style={{width:"100%",display:"flex",alignItems:"center",gap:8,padding:"7px 10px",border:"none",background:"none",cursor:"pointer",textAlign:"left",borderRadius:6,fontFamily:"'Inter',sans-serif"}}
              onMouseEnter={e=>e.currentTarget.style.background="#f9fafb"} onMouseLeave={e=>e.currentTarget.style.background="none"}>
              <div style={{width:16,height:16,borderRadius:4,border:`1.5px solid ${m.bloccato?"#e5e7eb":m.value?m.colore:"#d1d5db"}`,background:m.bloccato?(m.value?"#c4b5fd":"#f3f4f6"):m.value?m.colore:"#fff",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                {m.value && <Check size={11} color="#fff"/>}
              </div>
              <span style={{fontSize:13}}>{m.emoji}</span>
              <span style={{fontSize:12.5,fontWeight:600,color:m.value?"#111827":"#6b7280",flex:1}}>{m.label}</span>
              {m.bloccato && <Lock size={12} color="#a78bfa"/>}
            </button>
          ))}
          {avviso && (
            <div style={{margin:"6px 4px 2px",padding:"8px 10px",...STILE_AVVISO_VIOLA,fontSize:12,fontWeight:600,display:"flex",alignItems:"center",gap:6}}>
              <Lock size={13}/> Contatta l'Admin per farti abilitare
            </div>
          )}
        </div>,
        document.body
      )}
    </>
  );
}
